var map = {
	"./aquistition-green.png": "855f",
	"./best_price-green.png": "0022",
	"./engine-green.png": "93df",
	"./exterior-green.png": "2a20",
	"./interior-green.png": "0ea3",
	"./luxury-green.png": "0d48",
	"./new_tech-green.png": "4cbf",
	"./operatin_cost-green.png": "fda4",
	"./safety-green.png": "6ddb",
	"./spacious-green.png": "1848",
	"./wheel-green.png": "d0ce"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8b15";